import { render, staticRenderFns } from "./releasing.vue?vue&type=template&id=f2bff140&scoped=true"
import script from "./releasing.vue?vue&type=script&lang=js"
export * from "./releasing.vue?vue&type=script&lang=js"
import style0 from "./releasing.vue?vue&type=style&index=0&id=f2bff140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bff140",
  null
  
)

export default component.exports